/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  FadingHopeToken,
  FadingHopeTokenInterface,
} from "../FadingHopeToken";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class FadingHopeToken__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FadingHopeToken> {
    return super.deploy(overrides || {}) as Promise<FadingHopeToken>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FadingHopeToken {
    return super.attach(address) as FadingHopeToken;
  }
  connect(signer: Signer): FadingHopeToken__factory {
    return super.connect(signer) as FadingHopeToken__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FadingHopeTokenInterface {
    return new utils.Interface(_abi) as FadingHopeTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FadingHopeToken {
    return new Contract(address, _abi, signerOrProvider) as FadingHopeToken;
  }
}
